// extracted by mini-css-extract-plugin
export default {"root":"IconDropdownArrow_root__VNRSG"};